"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
const SvgIconIndex = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M4.75 5.5c-.854 0-1.59.347-2.06.877C2.218 6.907 2 7.583 2 8.25s.219 1.343.69 1.873c.47.53 1.206.877 2.06.877s1.59-.347 2.06-.877c.471-.53.69-1.206.69-1.873s-.219-1.343-.69-1.873c-.47-.53-1.206-.877-2.06-.877m5 .5a.75.75 0 1 0 0 1.5h11.5a.75.75 0 1 0 0-1.5zm-5 1c.48 0 .744.153.94.373s.31.544.31.877-.115.657-.31.877c-.196.22-.46.373-.94.373s-.744-.153-.94-.373a1.34 1.34 0 0 1-.31-.877c0-.333.115-.657.31-.877.196-.22.46-.373.94-.373m5 2a.75.75 0 1 0 0 1.5h8.5a.751.751 0 1 0 0-1.5zm-5 4c-.854 0-1.59.347-2.06.877-.471.53-.69 1.206-.69 1.873s.219 1.343.69 1.873c.47.53 1.206.877 2.06.877s1.59-.347 2.06-.877c.471-.53.69-1.206.69-1.873s-.219-1.343-.69-1.873C6.34 13.347 5.605 13 4.75 13m5 .5a.751.751 0 1 0 0 1.5h11.5a.751.751 0 1 0 0-1.5zm-5 1c.48 0 .744.153.94.373s.31.544.31.877-.115.657-.31.877c-.196.22-.46.373-.94.373s-.744-.153-.94-.373a1.34 1.34 0 0 1-.31-.877c0-.333.115-.657.31-.877.196-.22.46-.373.94-.373m5 2a.751.751 0 1 0 0 1.5h8.5a.751.751 0 1 0 0-1.5z"
  }));
};
var _default = exports.default = SvgIconIndex;